import { SearchOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React, { FunctionComponent, memo, useCallback } from 'react'

export interface TableFilterDropdownFooterProps {
  clearFilters?: () => void
  confirm: () => void
  close: () => void
  isSelected: boolean
}

export const TableFilterDropdownFooter: FunctionComponent<TableFilterDropdownFooterProps> =
  memo(props => {
    const handleReset = useCallback(() => {
      props.clearFilters?.()
      props.confirm()
    }, [props])

    const handleConfirm = useCallback(() => {
      props.confirm()
      props.close()
    }, [props])

    return (
      <div className="flex items-center justify-end space-x-2">
        <Button type="link" size="small" onClick={props.close}>
          Zavřít
        </Button>

        <Button
          onClick={handleReset}
          size="small"
          disabled={!props.isSelected}
          danger
        >
          Reset
        </Button>

        <Button
          type="primary"
          onClick={handleConfirm}
          icon={<SearchOutlined />}
          size="small"
        >
          Vyhledat
        </Button>
      </div>
    )
  })
